export default {
  description: 'Twórz i zarządzaj swoimi ustawieniami wstępnymi',
  presetLabel: 'Wybrane ustawienie wstępne',
  nameLabel: 'Nazwa ustawienia wstępnego',
  saveAsDefault: 'Zapisz ustawienia jako domyślne',
  publishGlobaly: 'Publikuj dla wszystkich użytkowników',
  publishGlobalyTooltip: 'Aby zmienić to ustawienie, skopiuj lub utwórz nowe ustawienie wstępne',
  defaultName: 'Nowe ustawienie wstępne',
  selectPreset: 'Wybierz ustawienie wstępne',
  reset: 'Zresetuj',
  apply: 'Zastosuj bez zapisywania',
};
